import React from 'react';
import { useMobile } from '../../../../hooks/useMobile';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: any) => ({
  header: {
    marginBottom: 4,
    fontWeight: 'bold',
  },
}));

function getHeaderVariant(mobile: boolean) {
  return mobile ? 'h5' : 'h4';
}

export default function Title({ title }) {
  const classes = useStyles();
  const mobile = useMobile('sm');

  return (
    <Typography
      variant={getHeaderVariant(mobile)}
      align={'center'}
      className={classes.header}
    >
      {title}
    </Typography>
  );
}
